import { env } from './environment';

export const apiConfig = {
  dataCollection: {
    baseUrl: env.api.dataCollection || '',
    timeout: env.api.timeout
  },
  vinProcessor: {
    baseUrl: env.api.vinProcessor || '',
    timeout: env.api.timeout
  },
  jobDispatcher: {
    baseUrl: env.api.jobDispatcher || '',
    timeout: env.api.timeout
  },
  healthMonitoring: {
    baseUrl: env.api.healthMonitoring || '',
    timeout: env.api.timeout
  },
  pipelineOrchestrator: {
    baseUrl: env.api.pipelineOrchestrator || '',
    timeout: env.api.timeout
  }
};
